import { render, staticRenderFns } from "./CashCouponPopup.vue?vue&type=template&id=20ffca74&scoped=true&"
import script from "./CashCouponPopup.vue?vue&type=script&lang=js&"
export * from "./CashCouponPopup.vue?vue&type=script&lang=js&"
import style0 from "./CashCouponPopup.vue?vue&type=style&index=0&id=20ffca74&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ffca74",
  null
  
)

component.options.__file = "CashCouponPopup.vue"
export default component.exports